(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-learning-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aum-hub').forEach(function (hub) {
  var cards = hub.querySelectorAll('.aum-hub__card');
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.getAttribute('data-target');
      var panel = hub.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
      var isOpen = card.getAttribute('aria-expanded') === 'true';
      // close everything
      cards.forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
      hub.querySelectorAll('.aum-hub__answer').forEach(function (a) { a.hidden = true; });
      if (!isOpen && panel) {
        card.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-aumenta"]) return;
  try {
    
(function () {
  var bars = document.querySelectorAll('.ba__progress');
  if (!bars.length) return;
  function update() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? Math.min(100, (doc.scrollTop / max) * 100) : 0;
    var w = pct.toFixed(1) + '%';
    for (var i = 0; i < bars.length; i++) { bars[i].style.width = w; }
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
